import { StreetHeadingEnum } from "./shared/enums/street-heading-enum";
export class StreetsConstants {
    static Headings = {
        PageHeadings: "Street"
    };
    static SELECTED_STREET_GRAPHICS_LAYER = "selectedStreetGraphicsLayer";
}
export const StreetHeadingEnumHeadingLookup = new Map([
    [StreetHeadingEnum.Name, "currentName"],
    [StreetHeadingEnum.AlternativeName, "proposedName"],
    [StreetHeadingEnum.Place, "locationDescription"],
    [StreetHeadingEnum.Type, "featureType"],
    [StreetHeadingEnum.Ward, "ward"]
]);
